// store.ts
import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import rootReducer from './rootReducer';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

const logger = createLogger();

const disableReduxLogger = import.meta.env.VITE_DISABLE_REDUX_LOGGER;

// Logger needs to be the last middleware in chain
const middlewareList = disableReduxLogger === 'true' ? [] : [logger];

// Configure the store
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ thunk: true }).concat(middlewareList),
});

// Derive the RootState type from the rootReducer
export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

// Create a typed `useAppDispatch` hook
export const useAppDispatch: () => AppDispatch = useDispatch;

// Create a typed `useAppSelector` hook — use instead of plain `useSelector`
// so the `state` parameter is `RootState`, giving full autocomplete and
// removing the need for `(state: RootState)` annotations at every call site.
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
